import { STORE_TYPE_BITRIX, STORE_TYPE_YCP } from './constants';
import { type StoreType } from './types';

/** Типы внешнего чекаута: Bitrix и YCP. */
export type ExternalCheckoutStoreType = Extract<StoreType, 'Bitrix' | 'YCP'>;

/**
 * Проверяет, является ли `type` типом внешнего чекаута (Bitrix / YCP).
 *
 * @param type - Тип магазина из `StoreInfoRequestContext`.
 * @returns `true`, если тип — Bitrix или YCP.
 * @kind helper
 */
export function isExternalCheckoutStoreType(type: StoreType): type is ExternalCheckoutStoreType {
    return type === STORE_TYPE_BITRIX || type === STORE_TYPE_YCP;
}
